import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import store from "../store";
import Login from "../views/Login.vue";
import Cadastro from "../views/Cadastro.vue";
import Dashboard from "../views/Dashboard.vue";
import Clientes from "../views/Clientes.vue";
import Honorarios from "../views/Honorarios.vue";
import Home from "../views/Home.vue";
import ChatDashboard from "../views/ChatDashboard.vue";
import Perfil from "../views/Perfil.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/cadastro",
    name: "Cadastro",
    component: Cadastro
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "Home",
        component: Home
      },
      {
        path: "clientes",
        name: "Clientes",
        component: Clientes
      },
      {
        path: "honorarios",
        name: "Honorarios",
        component: Honorarios
      },
      {
        path: "perfil",
        name: "Perfil",
        component: Perfil
      }
    ]
  },
  {
    path: "/assistente",
    name: "AssistenteIA",
    component: ChatDashboard,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.isAuthenticated) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
